import type { RootState } from '@/store';

export const selectPayment = (state: RootState) => state?.payment;

export const selectPaymentPaidAmounts = (state: RootState) => selectPayment(state)?.paidAmounts;
